import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import ValidatedFormField from '../form/ValidatedField';
import CardHolderName from './CardHolderName';
import CardNumber from './CardNumber';
import CardExpiryMonth from './CardExpiryMonth';
import CardExpiryYear from './CardExpiryYear';
import CardSecurityCode from './CardSecurityCode';
import FormError from '../form/Error';
import SlashIcon from '../icons/SlashIcon';
import CardForm from '../../records/payment/CardForm';


function CardDetails (props) {
    const isExpired = props.form.getError('isExpired');
    const Wrapper = props.isSubForm ? 'div' : 'form';
    return (
        <Wrapper>
            <Row>
                <Col xs={12}>
                    <CardHolderName {...props} required outsideLabel />
                </Col>
            </Row>

            <Row>
                <Col md={6} className="card-details__number">
                    <CardNumber {...props} required outsideLabel showPlaceholder />
                </Col>

                <Col md={6} className="card-details__expiry-and-cvv">
                    <Row className="row-padding-md">
                        <Col xs={12} sm={8}>
                            <div className="card-expiry-with-slash">
                                <CardExpiryMonth {...props} required outsideLabel />
                                <SlashIcon className="card-slash" />
                                <CardExpiryYear {...props} required outsideLabel />
                            </div>
                        </Col>
                        <Col xs={6} sm={4}>
                            <CardSecurityCode {...props} required outsideLabel />
                        </Col>
                    </Row>
                    {isExpired && (
                        <Row>
                            <Col xs={12} className="card-error">
                                <FormError message={isExpired} />
                            </Col>
                        </Row>
                    )}
                </Col>
            </Row>
        </Wrapper>
    );
}

CardDetails.propTypes = {
    isSubForm: PropTypes.bool,
    showLogos: PropTypes.bool,
    form: PropTypes.instanceOf(CardForm).isRequired,
    ..._.pick(ValidatedFormField.propTypes, [ 'form', 'onChange', 'disabled', 'visited', 'validation' ])
};

CardDetails.defaultProps = {
    isSubForm: false,
};

export default CardDetails;



// WEBPACK FOOTER //
// ./src/components/payment/CardDetails.js